import { ReactNode, CSSProperties, Key, MutableRefObject, } from "react";
import { RouteLinkProps } from "../RouteLink/interface";

export interface SuperSelectProps extends RenderLabelProps, SelectDropdownBaseProps, SelectInputBaseProps {
  /** 样式 */
  style?: CSSProperties,
  /** 类名 */
  className?: string;
  /** 对外方法 */
  actionRef?: MutableRefObject<SuperSelectActionType>;
  /** 下拉框大小 */
  size?: SizeType;
  /** 引用外部字典的code */
  enumCode?: string;
  /** 支持清除 */
  allowClear?: boolean;
  /** 是否默认展开下拉菜单 */
  defaultOpen?: boolean;
  /** 指定默认选中的条目 */
  defaultValue?: SelectValue;
  /** 是否展开下拉菜单 */
  open?: boolean;
  /** 禁用时是否显示虚线的下边框 */
  disabledBorderDashed?: boolean;
  /** 禁用是显示内容 */
  disabledRender?: ReactNode | ((data?: any) => ReactNode);
  /** 自定义选中标签显示 */
  onRenderLabel?: (record: any) => void;
  /** 失去焦点时回调 */
  onBlur?: () => void;
  /** 获得焦点时回调 */
  onFocus?: () => void;
  /** 选中 option，或 input 的 value 变化时，调用此函数 */
  onChange?: (value?: SelectValue, options?: SelectOption | SelectOption[]) => void;
  /** 被选中时调用，参数为选中项的 value (或 key) 值 */ 
  onSelect?: (value?: SelectValue, options?: SelectOption | SelectOption[]) => void;
  /** 点击全选回调 */
  onSelectedAll?: (values?: Key[], options?: SelectOption[]) => void;
}

export interface SelectInputBaseProps {
  /** value为空是提示文字 */
  placeholder?: string;
  /** 是否在加载中状态 */
  loading?: boolean;
  /** 支持清除 */
  allowClear?: boolean;
  /** 是否禁用 */
  disabled?: boolean;
  /** 清除内容时回调 */
  onClear?: () => void;
}

export interface RenderLabelProps {
  /** 禁用文字是否可以复制 */
  copy?: boolean;
  /** 禁用时超出字符串是否省略 */
  isDisabledEllipsis?: boolean;
  /** 禁用文字链接配置 */
  routeLinkProps?: RouteLinkProps;
}

export interface SelectDropdownBaseProps {
  /** 值 */
  value?: SelectValue;
  /** 是否在加载中状态 */
  loading?: boolean;
  /** 选项是否可以进行搜索 */
  showSearch?: boolean;
  /** 下拉层级 */
  zIndex?: number;
  /** 模式 */
  mode?: modeType;
  /** 选项 */
  options?: SelectOption[];
  /** 下拉菜单的 className 属性 */
  popupClassName?: string;
  /** 下拉菜单的 style 属性 */
  dropdownStyle?: CSSProperties;
  /** 下拉菜单和选择器同宽。默认将设置 min-width，当值小于选择框宽度时会被忽略 */
  dropdownMatchSelectWidth?: number;
  /** 设置弹窗滚动高度 */
  listHeight?: number;
  /** 自定义下拉框底部内容 */
  dropdownFooterRender?: ReactNode;
  /** 自定义节点 label、subLabel、value、 defauleSelected 的字段 */
  fieldNames?: FieldNamesType;
  /** 是否为本地搜索 */
  isLocalSearch?: boolean;
  /** 搜索框提示 */
  searchPlaceholder?: string;
  /** 本地搜索时是否区分大小写 */
  searchDiscriminateCase?: boolean;
  /** 是否将字母自动转换成大写 */
  isUpperCase?: boolean;
  /** 是否显示全选按钮 只有多选时才有效 */
  showAllSelected?: boolean;
  /** 自定义Option选项 */
  renderOption?: (record: any) => ReactNode;
  /** 菜单渲染父节点。默认渲染到 body 上 */
  getPopupContainer?: () => HTMLElement | HTMLElement;
  /** 接收 inputValue option 两个参数，当 option 符合筛选条件时，应返回 true，反之则返回 false */
  filterOption?: (option: SelectOption, inputValue?: SelectValue) => boolean;
  /** 文本框搜索值变化时回调 */
  onSearch?: (searchValue?: string) => void;
}

export interface DropdownOffset {
  /** 距离页面左部的距离 */
  left: number;
  /** 距离页面头部的距离 */
  top: number;
  /** 距离页面底部的距离 */
  bottom?: number;
}

export interface SelectOption {
  /** 标题 */
  label?: ReactNode;
  /** 值 */
  value?: string | number | boolean;
  /** 副标题 */
  subLabel?: ReactNode;
  /** 子节点 目前只支持到二级节点 */
  children?: SelectOption[];
  /** 其他 */
  [prop: string]: any;
}
export type FieldNamesType = Partial<IfieldNames>;
export interface IfieldNames {
  /** 标题 */
  label: string;
  /** 副标题 */
  subLabel: string;
  /** 值 */
  value: string;
  /** 子节点 */
  children: string;
  /** 子节点标题 */
  childrenLabel: string;
  /** 子节点副标题 */
  childrenSubLabel: string;
  /** 子节点值 */
  childrenValue: string;
  /** 默认选项字段 */
  defauleStatus?: string;
}
export type SelectValue = Key | Key[] | boolean;
export type SizeType = 'small' | 'middle' | 'large';
export type modeType = 'multiple' | 'tags';
/** fieldNames默认值 */
export const DEFAULT_FIELD_NAMES: IfieldNames = {
  label: 'label',
  subLabel: 'subLabel',
  value: 'value',
  children: 'children',
  childrenLabel: 'label',
  childrenSubLabel: 'subLabel',
  childrenValue: 'value',
};
export const IS_CHILDREN: string = 'IS_CHILDREN';
interface SuperSelectAction {
  /** 获取焦点 */
  focus: () => void;
  /** 失去焦点 */
  blur: () => void;
  /** 清空搜索值 */
  emptySearch: () => void;
  /** 获取所有选项 */
  getOption: () => SelectOption[];
};
export type SuperSelectActionType = SuperSelectAction | undefined;

interface SelectDropdownAction {
  /** 清空搜索值 */
  onEmptySearch: () => void;
}
export type SelectDropdownActionType = SelectDropdownAction | undefined;
